var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PagedCategory',_vm._b({},'PagedCategory',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }